/**
 * Ab welchem Anteil ihrer Auflösung die feinere Kachelstufe übernimmt
 * (canvas-engine TileManager.detailThreshold). 1 = erst bei 1:1, 0,5 = schon
 * bei halber Größe: die Karte wird früher scharf, lädt dafür mehr Kacheln.
 * Alex 2026-10-22 im Karten-Labor: „Feiner ab 50 % gefällt mir am besten".
 *
 * Wert je Projekt in `tileMap.map.tileDetailThreshold`. Der Renderer wird je
 * Seite neu angelegt, deshalb setzen wir den Wert an jedem neuen TileManager.
 * Ältere Engine-Versionen ohne das Feld ignorieren ihn.
 */
import { tileMapConfig } from '@/config/tileMapConfig'

type Rec = Record<string, unknown>

export function kachelSchaerfeStarten(): void {
  const wert = (tileMapConfig.map as unknown as Rec | undefined)?.tileDetailThreshold
  if (typeof wert !== 'number' || typeof window === 'undefined') return
  let letzter: unknown = null
  window.setInterval(() => {
    const r = (window as unknown as { tscheppaMap?: { getRenderer?: () => Rec | null } }).tscheppaMap?.getRenderer?.()
    const tm = r?.tileManager as Rec | undefined
    if (!tm || tm === letzter) return
    letzter = tm
    tm.detailThreshold = wert
  }, 500)
}
